import dayjs from "dayjs";
import * as Yup from "yup";
import { STATUS_BADGE_TYPE } from "../../../../../../../../../components";
import { DATE_FORMAT } from "../../../../../../../../../helpers/constants";
import { KeyValue } from "../../../../../../../../../helpers/types/common";
import { AddGoalFormKey } from "./Models";

export const AddGoalSchema = (commonValidationMessages: KeyValue) =>
  Yup.object().shape(
    {
      [AddGoalFormKey.name]: Yup.string().required(
        commonValidationMessages.requiredValidation,
      ),
      [AddGoalFormKey.theme]: Yup.string(),
      [AddGoalFormKey.description]: Yup.string(),
      [AddGoalFormKey.status]: Yup.string().default(
        STATUS_BADGE_TYPE.notYetStarted,
      ),

      [AddGoalFormKey.completionDateWithoutFormatted]: Yup.object().nullable(),
      [AddGoalFormKey.programStartDateWithoutFormatted]:
        Yup.object().nullable(),
      [AddGoalFormKey.dueDate]: Yup.string().nullable(),
      [AddGoalFormKey.completionDate]: Yup.string()
        .nullable()
        .when([AddGoalFormKey.programStartDateWithoutFormatted], {
          is: (completionDate: string) => {
            return !!completionDate;
          },
          then: (schema) => {
            return schema.test(
              "is-after",
              commonValidationMessages.goalCompletionDateValidationMessage,
              (_, value) => {
                if (!value.parent?.completionDateWithoutFormatted) {
                  return true;
                }
                const completionDateToCompare = dayjs(
                  value.parent?.completionDateWithoutFormatted?.format(
                    DATE_FORMAT.YYYY_MM_DD_HYPHEN,
                  ),
                );
                const programStartDateToCompare = dayjs(
                  value.parent?.programStartDateWithoutFormatted,
                );
                const isAfter = completionDateToCompare?.isAfter(
                  programStartDateToCompare,
                  "day",
                );
                const isEqual = completionDateToCompare?.isSame(
                  programStartDateToCompare,
                  "day",
                );
                return isAfter || isEqual;
              },
            );
          },
        }),
      [AddGoalFormKey.notes]: Yup.string(),
    },
    [[AddGoalFormKey.completionDate, AddGoalFormKey.completionDate]],
  );
